<!-- Beneficiary Info - Compact -->
<div class="card shadow-sm mb-2" >
    <div class="card-body p-2">
        <div class="row g-2">
            
            <div class="col col-md-12" *ngIf="itemPrestation">
                <div class="row g-2">
                    <div class="col-auto text-center">
                <img  [src]="itemPrestation.praticien_prescript_image_url" class="rounded-circle mb-1" style="width: 50px; height: 50px;">
            </div>
                    <div class="col-md-5">
                        <label class="small">Paticien</label>
                        <input disabled [(ngModel)]="itemPrestation.praticien_prescript_libelle" type="text" class="form-control form-control-sm">
                    </div>
                 
                    <div class="col-md-3">
                        <label class="small">Spécialité</label>
                        <input disabled [(ngModel)]="itemPrestation.praticien_prescript_specialite" type="text" class="form-control form-control-sm">
                    </div>
                    <div class="col-md-2" *ngIf="itemPrestation.ged_file_url">
                        <label class="small">Ordonnance</label>
                        <a href="{{itemPrestation.ged_file_url}}" download target="_blank">Télécharger</a>
                    </div>
                    
                </div>
              
            </div>
        </div>
    </div>
</div>